import { jsxs, jsx } from "react/jsx-runtime";
import { Stack, Box } from "@mui/material";
import cn from "../../../../../vendor/classnames/index.js";
import { memo, useMemo } from "react";
import { CalendarButton } from "../CalendarButton.js";
import { getHoverState } from "./utils/getHoverState.js";
import { getSelectedState } from "./utils/getSelectedState.js";
import { inheritDataTestId } from "../../../../../utils/dataTestId.js";
const classNames = {
  rangeCommon: "range-common",
  range: "range",
  rangeEnd: "range-end",
  rangeStart: "range-start",
  hoverRange: "hover-range",
  hoverRangeEnd: "hover-range-end",
  hoverRangeStart: "hover-range-start"
}, classNameMap = {
  range: classNames.range,
  "range-end": classNames.rangeEnd,
  "range-start": classNames.rangeStart,
  "hover-range": classNames.hoverRange,
  "hover-range-end": classNames.hoverRangeEnd,
  "hover-range-start": classNames.hoverRangeStart
}, CalendarCell = memo(
  ({
    content,
    current,
    onClick,
    onHover,
    selected,
    isRange,
    date,
    hoverDate,
    disabled,
    ...props
  }) => {
    const hoverType = useMemo(
      () => disabled ? void 0 : getHoverState({
        selected,
        isRange,
        date,
        hoverDate
      }),
      [date, disabled, hoverDate, isRange, selected]
    ), isHoverRange = !!hoverType, type = useMemo(() => getSelectedState({ selected, isRange, date }), [date, isRange, selected]);
    return /* @__PURE__ */ jsxs(
      Stack,
      {
        sx: style.cell,
        className: cn(
          type && classNameMap[type],
          hoverType && classNameMap[hoverType],
          (isRange || isHoverRange) && classNames.rangeCommon,
          "date-cell"
        ),
        onMouseOver: () => onHover == null ? void 0 : onHover(date),
        onMouseOut: () => onHover == null ? void 0 : onHover(),
        ...props,
        children: [
          isHoverRange && hoverType && /* @__PURE__ */ jsx(Box, { sx: style.hoverRange, className: "hover-range-patch" }),
          isRange && type && /* @__PURE__ */ jsx(Box, { sx: style.range, className: "range-patch" }),
          content && /* @__PURE__ */ jsx(
            CalendarButton,
            {
              selected: type === "selected" || type === "range-end" || type === "range-start",
              current,
              onClick: () => onClick == null ? void 0 : onClick(date),
              disabled,
              "data-test-id": inheritDataTestId(props, "day-calendar-btn"),
              children: content
            }
          )
        ]
      }
    );
  }
), style = {
  cell: {
    "--size": "42px",
    width: "var(--size)",
    height: "var(--size)",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    position: "relative",
    backgroundColor: (t) => t.palette.picker.primary.segment.normal.bg.default,
    boxSizing: "border-box"
  },
  hoverRange: {
    "--range-height": "36px",
    "--border-range-color": (t) => t.palette.picker.primary.segment.interim.bg.hover,
    position: "absolute",
    boxSizing: "border-box",
    [`.${classNames.rangeCommon} &`]: {
      height: "var(--range-height)",
      borderWidth: "1px !important"
    },
    [`.${classNames.hoverRange} &`]: {
      width: "96%",
      borderBottom: "1px dashed var(--border-range-color)",
      borderTop: "1px dashed var(--border-range-color)"
    },
    [`.${classNames.hoverRangeEnd} &`]: {
      width: "50%",
      left: 0,
      borderBottom: "1px dashed var(--border-range-color)",
      borderTop: "1px dashed var(--border-range-color)"
    },
    [`.${classNames.hoverRangeStart} &`]: {
      width: "50%",
      right: 0,
      borderBottom: "1px dashed var(--border-range-color)",
      borderTop: "1px dashed var(--border-range-color)"
    }
  },
  range: {
    "--range-height": "36px",
    "--border-range-color": (t) => t.palette.picker.primary.segment.interim.bg.hover,
    "--range-bg-color": (t) => t.palette.picker.primary.segment.interim.bg.default,
    //
    position: "absolute",
    boxSizing: "border-box",
    [`.${classNames.rangeCommon} &`]: {
      height: "var(--range-height)"
    },
    [`.${classNames.range} &`]: {
      width: "100%",
      backgroundColor: "var(--range-bg-color)"
    },
    [`.${classNames.rangeEnd} &`]: {
      width: "50%",
      left: 0,
      backgroundColor: "var(--range-bg-color)"
    },
    [`.${classNames.rangeStart} &`]: {
      width: "50%",
      right: 0,
      backgroundColor: "var(--range-bg-color)"
    }
  }
};
export {
  CalendarCell
};
//# sourceMappingURL=CalendarCell.js.map
